import { SET_WORK_ORDER_LABELS_PENDING } from '../actions/work_orders_actions';
import { WorkOrderStarLabelsStoreState } from '../types/models';

// Transient, per-work-order "labels are being assigned" flag for the Stars + Labels
// feature. It lives in its own slice (not in work_orders) because it is ephemeral UI
// state shared across surfaces (row / detail header) while the Add Label modal saves —
// it is not part of the work order CRUD record.
const initialState: WorkOrderStarLabelsStoreState = {
	labelsPendingById: {},
};

export default (oldState = initialState, action): WorkOrderStarLabelsStoreState => {
	Object.freeze(oldState);
	switch (action.type) {
		case SET_WORK_ORDER_LABELS_PENDING: {
			const key = String(action.workOrderId);
			const labelsPendingById = { ...oldState.labelsPendingById };
			if (action.pending) {
				labelsPendingById[key] = true;
			} else {
				delete labelsPendingById[key];
			}
			return { ...oldState, labelsPendingById };
		}
		default:
			return oldState;
	}
};
